import { styled } from 'styled-system/jsx'

const TenancyGrid = styled('div', {
  base: {
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    width: '100%',
  },
})

const TenancyCardButton = styled('button', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    width: '100%',
    border: '2px solid transparent',
    borderRadius: 'lg',
    background: 'transparent',
    padding: '0',
    cursor: 'pointer',
    textAlign: 'left',
  },
  variants: {
    isSelected: {
      true: { borderColor: 'quickpass.primary' },
      false: {},
    },
  },
  defaultVariants: {
    isSelected: false,
  },
})

const UnitLabel = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const StatusPill = styled('span', {
  base: {
    alignSelf: 'flex-start',
    paddingX: '10px',
    paddingY: '3px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    backgroundColor: '#EFE9FF',
    color: '#5B3FCC',
  },
})

const RentLine = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

export { TenancyGrid, TenancyCardButton, UnitLabel, StatusPill, RentLine }
